$pill-stroke: 2.75px;

.scorePill {
  position: relative;
  display: inline-flex;
  height: 2rem;
  flex-shrink: 0;
  align-items: center;
  gap: 0.3125rem;
  padding-block: 0;
  padding-inline: 0.5625rem 0.75rem;
  color: var(--color-foreground);

  > svg:not(.scorePillOutline) {
    width: 0.875rem;
    height: 0.875rem;
  }
}

.scorePillOutline {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;

  rect {
    x: $pill-stroke * 0.5;
    y: $pill-stroke * 0.5;
    width: calc(100% - #{$pill-stroke});
    height: calc(100% - #{$pill-stroke});
    rx: calc(1rem - #{$pill-stroke * 0.5});
    fill: none;
    stroke-width: $pill-stroke;
  }
}

.scorePillTrack {
  stroke: var(--color-muted-light);
}

.scorePillValue {
  stroke: var(--score-color);
  stroke-linecap: round;
  transition: stroke-dashoffset 700ms var(--ease-strong-out);
}


@media (prefers-reduced-motion: reduce) {
  .scorePillValue { transition: none; }
}
